import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { AuthContext } from 'contexts/AuthContext';

import { useAppDispatch } from 'redux/hooks';
import { logout } from 'redux/slices/currentUser';
import { setQueries } from 'redux/slices/query';

const useHeader = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const authContext = useContext(AuthContext);

  const logoutUser = () => {
    authContext.signOut();
    navigate('/');
    dispatch(setQueries({}));
    dispatch(logout());
  };

  return {
    logoutUser,
  };
};

export { useHeader };
